import "./styles/globals.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./app/App";
import { DevTools } from "./app/DevTools";
import { MsalProvider } from "@azure/msal-react";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import MsalInstance from "./services/authClient";
import { getBrand } from "./brand/brand";

async function initMsal() {
	await MsalInstance.initialize();
}

initMsal();

// The shipped index.html carries the Mee title (a deployed stack's is rewritten
// by branding/apply-brand.mjs); set the brand's now so screens that never set a
// title themselves - sign-in, 404 - show the right product.
document.title = getBrand().consumerTitle;

const root = createRoot(document.getElementById("root") as HTMLElement);

const queryClient = new QueryClient({
	defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } }
});

const appInsightsConnString = window._env_.REACT_APP_AI_CONNSTRING;

if (appInsightsConnString) {
	const appInsights = new ApplicationInsights({
		config: {
			connectionString: appInsightsConnString.replace("%3D", "=") // we have to escape the = because of how we load in the vars at build time,
		}
	});
	appInsights.loadAppInsights();
	appInsights.trackPageView(); // This only tacks a full page load, no react routing
}

root.render(
	<BrowserRouter basename={window._env_.PUBLIC_URL}>
		<QueryClientProvider client={queryClient}>
			<MsalProvider instance={MsalInstance}>
				<App />
			</MsalProvider>
			<DevTools />
		</QueryClientProvider>
	</BrowserRouter>
);
